
    var riot = require('riot')
    riot.tag2('treeviewnode', '<ul if="{!opts.folded && !opts.loading}" data-is="with-transition" transition="{opts.transition}" class="{node.ulCss()}" ondragover="{!opts.depth ? rootEvents.onDragOver : null}" ondragenter="{!opts.depth ? rootEvents.onDragEnter : null}" ondragleave="{!opts.depth ? rootEvents.onDragLeave : null}" ondrop="{!opts.depth ? rootEvents.onDrop : null}"> <li each="{item in getModel()}" class="{node.liCss(item)}" draggable="{node.getDragEvents(item).draggable}" ondragstart="{node.getDragEvents(item).onDragStart}" ondragover="{node.getDragEvents(item).onDragOver}" ondragenter="{node.getDragEvents(item).onDragEnter}" ondragleave="{node.getDragEvents(item).onDragLeave}" ondragend="{node.getDragEvents(item).onDragEnd}" ondrop="{node.getDragEvents(item).onDrop}"> <span class="{parent.node.mixCss(⁗item⁗)}" onclick="{parent.node.onClick(item)}"> <virtual if="{!parent.opts.displaytag}"> {parent.opts.display(item, parent.opts)} </virtual> <virtual if="{parent.opts.displaytag}" data-is="{parent.opts.displaytag(item, parent.opts)}" item="{item}" inputs="{inputs.get()}"></virtual> <span if="{node.hasChildren(item) || node.isAsync(item) && !parent.opts.noopener}" class="{node.mixCss(⁗opener⁗)}" onclick="{node.onOpener(item)}"></span> </span> <treeviewnode if="{node.hasChildren(item) || node.isAsync(item)}" opts="{parent.opts}" selection="{parent.opts.selection}" model="{getChildModel(item)}" filteredmodel="{getChildFiltered(item)}" ancestors="{getAncestors(item)}" depth="{parent.opts.depth + 1}" folded="{node.isFolded(item)}" loading="{node.isAsync(item) && !node.isFolded(item)}"> </TreeViewNode> </li> </ul> <span if="{opts.loading}"></span>', '', '', function(opts) {
"use strict";

var _this = this;

var _core = require("../../core");

var _mixins = require("../mixins");

this.mixin((0, _mixins.optsMixin)());

// Logic //

this.unfolded = [];

this.getModel = function () {
    return _this.opts.searched ? _this.opts.model.filter(function (m) {
        return _this.opts.filteredmodel.has(m);
    }) : _this.opts.model;
};

this.getChildModel = function (item) {
    var childModel = item[_this.opts.category];

    /* If data has to be retrieved asynchronously */
    if (_this.node.isAsync(item) && !_this.node.isFolded(item) && _this.node.pending.indexOf(item) < 0) {
        _this.node.unwrapPromise(item);
    }
    if (!_this.node.isAsync(item)) {
        childModel = _this.opts.sort ? childModel.sort(_this.opts.sort) : childModel;
    }

    return childModel;
};

this.getChildFiltered = function (item) {
    return _this.opts.searched ? _this.opts.filteredmodel.get(item) : null;
};

this.getAncestors = function (item) {
    return [].concat(_this.opts.ancestors, [item]);
};

// Boilerplate //

var mock = function mock() {
    _this.opts.onSelect = _this.opts.onselection;
    _this.opts.disabled = _this.opts.disable;
};
this.on("update", mock);
mock();

this.inputs = { get: function get() {
        return _this.opts;
    } };
this.state = {
    get: function get() {
        return _this;
    },
    set: function set(s) {
        for (var key in s) {
            if (key in _this) _this[key] = s[key];
        }
    }
};
this.node = new _core.TreeNode(this.inputs, null, this.state, this.update);
this.rootEvents = this.node.getDragEvents();
});

    
  


//////////////////
// WEBPACK FOOTER
// ./src/riot/components/TreeViewNode.tag
// module id = 21
// module chunks = 0